import React, { createContext, useState, useContext, useEffect } from 'react';
import { AuthContext } from './AuthContext';

const STORE_API_URL = process.env.REACT_APP_API_URL;

export const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  const { token, role } = useContext(AuthContext);
  const [stores, setStores] = useState(['Not initialized']); // State to hold available stores
  const [selectedStore, setSelectedStore] = useState(''); // State for the selected store
  const [storeName, setStoreName] = useState('');
  const [storeLogo, setStoreLogo] = useState('');
  const [store, setStore] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const setStoreLocalStorage = (storeId) => {
    setSelectedStore(storeId);
    localStorage.setItem('selectedStore', storeId);
  };

  // Fetch stores from the backend
  const fetchStores = async () => {
    if (!token) return;

    setLoading(true);
    setError(null);
  
    try {
      const url = role === 'super' 
        ? `${STORE_API_URL}/super/stores` 
        : `${STORE_API_URL}/stores`;
  
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error fetching stores.');
      }

      const storesData = await response.json();
      setStores(storesData);
      
      if (storesData.length > 0) {
        const storedStoreId = localStorage.getItem('selectedStore');
        const initialStoreId = storedStoreId || storesData[0]._id;

        console.log('Setting store id to: ' + initialStoreId);
        setSelectedStore(initialStoreId);

        //console.log('storesData: ' + JSON.stringify(storesData))
        const initialStore = storesData.find(store => store._id === initialStoreId);
        console.log('Store Name: ' + initialStore.name);
        setStore(initialStore || '');
        setStoreName(initialStore.name || '');
        // Set store logo after a delay of 2 seconds
        // Idea is to show the phosphor portal logo for a brief second, just to be cool..!
        // Making the glitch into a feature.. 
        setTimeout(() => {
          setStoreLogo(initialStore.logo || '');
        }, 2000);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchStores();
    }
  }, [token]);

  return (
    <StoreContext.Provider
      value={{
        store,
        stores,
        selectedStore,
        setSelectedStore,
        setStoreLocalStorage,
        storeLogo,
        storeName,
        setStoreName,
        setStoreLogo,
        loading,
        error,
        fetchStores, // Expose fetchStores for manual calls if needed
      }}
    >
      {children}
    </StoreContext.Provider>
  );
};
